import { uniqueAndSorted } from "@faire/deprecated-retailer-visitor-shared/lib/uniqueAndSorted";
import { createCategoryPageQueryKeyPrefix } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/__internal__/createCategoryPageQueryKeyPrefix";
import { ISearchRequestReferrer } from "@faire/web-api--source/indigofair/data/ISearchRequestReferrer";

export type ICategoryPageQueryKeys = ReturnType<
  typeof createCategoryPageQueryKeys
>;

export const createCategoryPageQueryKeys = ({
  navigationPath,
  filterKeys,
  oneIndexedPageNumber,
  requestReferrer,
}: {
  navigationPath: string;
  filterKeys: string[];
  oneIndexedPageNumber: number;
  requestReferrer: ISearchRequestReferrer;
}) => {
  return [
    ...createCategoryPageQueryKeyPrefix({ navigationPath }),
    uniqueAndSorted(filterKeys),
    oneIndexedPageNumber,
    requestReferrer,
  ] as const;
};
